export default __webpack_public_path__ + "static/media/primero_lee_logo.f0f61d2d.bin";